export default __webpack_public_path__ + "static/article-finance-debt-consolidation-21d8f92ee230fa29fb2ff046276b35e6.jpg";